<template>
    <div class="flex">
        <ul class="z-0 flex">
            <li
                v-for="node in navData.nodes"
                :key="node.title"
                class="px-3 h-full flex items-center"
                :class="node.title == 'Members' ? 'border-l border-grey-shadow ml-2 pl-6' : ''"
                @mouseover="activate(node)"
                @mouseleave="deactivate"
            >
                <a :href="node.url" class="NavDesk__item" @focus="deactivate">
                    <span>{{ node.title }}</span>
                </a>
                <button
                    class="flex-shrink-0"
                    aria-has-popup="true"
                    :aria-label="node.title + ' menu'"
                    aria-expanded="false"
                    @keyup.space="toggleActive(node)"
                    @keyup.enter="toggleActive(node)"
                >
                    <!-- prettier-ignore -->
                    <svg class="px-2 py-4 w-7 h-full NavDesk__megamenu-icon text-blue-500" role="img" focusable="false" aria-label="" width="11" height="6" viewbox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.8675 3.89223L1.77622 0.0241611L0.760306 1.04123L5.84334 6L11 1.06654L9.93346 0L5.8675 3.89223Z" fill="currentColor"/>
                    </svg>
                </button>
                <hr
                    class="absolute bottom-0 left-0 w-full text-blue-100"
                    :class="isActive(node) ? 'opacity-100 z-10' : 'opacity-0 z-negative'"
                />
                <Megamenu v-show="isActive(node)" :node="node" :mega-menu-active="!!activeItem" />
            </li>
        </ul>
        <a class="ml-3 btn NavDesk__button" target="_blank" :href="ctaUrl" @focus="deactivate">
            {{ ctaText }}
        </a>
    </div>
</template>

<script>
import Megamenu from './Megamenu.vue';
export default {
    components: { Megamenu },
    props: {
        navData: {
            type: Object,
            required: true
        },
        ctaText: {
            type: String,
            required: true
        },
        ctaUrl: {
            type: String,
            required: true
        }
    },
    data: () => ({
        activeItem: null
    }),
    methods: {
        activate(node) {
            this.activeItem = node.title;
            document.body.classList.add('mega-menu-active');
        },
        deactivate() {
            this.activeItem = null;
            document.body.classList.remove('mega-menu-active');
        },
        toggleActive(node) {
            if (this.activeItem) {
                this.deactivate();
            } else {
                this.activeItem = node.title;
            }
        },
        isActive(node) {
            return node.title === this.activeItem;
        }
    }
};
</script>
<style>
/* .mega-menu-active .NavDesk li:hover > hr {
    @apply opacity-100 z-10 !important;
} */

/*     .mega-menu-active & {
        @apply bg-white;
    } */

/* .mega-menu-active .NavDesk:after {
    @apply h-screen opacity-100;
}

.search-active .NavDesk:after {
    @apply h-screen opacity-100 z-10;
} */

.NavDesk__item {
    @apply text-blue-500 flex items-center h-full;
}

.mega-menu-active .NavDesk__item {
    @apply text-grey-500;
}

li:hover .NavDesk__item {
    @apply text-blue-500;
}
</style>
